import { Button, Upload, Modal } from "antd";
import { ExclamationCircleOutlined, UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { openNotificationWithIcon, uploadDocument } from "../../../utils/functions";
import { updateUnsafe } from "../../../api/participante";

const { confirm } = Modal;

function UploadDeleteDocument(props) {
  const {
    title = "",
    type = "",
    nrodocumento = "",
    recordId = "",
    urlName = "",
    existUrl = null,
    accept = ".pdf"
  } = props;

  const handleDelete = () => {
    confirm({
      title: (
        <p>
          ¿Estás seguro que deseas quitar <b className="text-blue-600">{title}</b>?
        </p>
      ),
      icon: <ExclamationCircleOutlined />,
      async onOk() {
        try {
          const res = await updateUnsafe({ [urlName]: "" }, recordId);

          openNotificationWithIcon("success", res.message);
          window.location.reload();
        } catch (err) {
          openNotificationWithIcon("error", err.message);
        }
      },
      onCancel() {
        return null;
      }
    });
  };

  return (
    <div className="mb-4 text-left">
      <span className="inline-block pb-2 font-semibold">{title}</span>
      <div className="flex justify-between">
        <Upload {...uploadDocument(type, nrodocumento)} accept={accept} maxCount={1}>
          <Button icon={<UploadOutlined />} disabled={existUrl}>
            Subir archivo
          </Button>
        </Upload>

        <Button icon={<DeleteOutlined />} onClick={handleDelete} disabled={!existUrl} />
      </div>
    </div>
  );
}

export default UploadDeleteDocument;
